var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContactBackground = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1242 813"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4099_10049)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint0_linear_4099_10049)",
  d: "M152.044 0H1341.62v813H1V114.745z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint1_linear_4099_10049)",
  d: "M1172.21 167.745v194.189H671V53h350.71z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#272727",
  strokeDasharray: "2 1",
  strokeWidth: 0.5,
  d: "M843.111 343.934V149.745L692.611 35H315"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint2_linear_4099_10049)",
  fillOpacity: 0.75,
  d: "m649.451 632-56.355 67.49H1V140.51l81-62h567.45z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint3_linear_4099_10049)",
  strokeWidth: 0.5,
  d: "M15.35 123.335v8.712l-4.579 8.954v13.948"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint4_linear_4099_10049)",
  strokeWidth: 0.5,
  d: "M4.137 224.68v-11.746l3.505-5.92v-13.948"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint5_linear_4099_10049)",
  strokeWidth: 0.5,
  d: "M23.936 104.09 6.883 116.317v38.322"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_bdiii_4099_10049)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 39,
  fill: "#2B2B2B",
  fillOpacity: 0.05,
  rx: 1,
  shapeRendering: "crispEdges",
  transform: "matrix(-1 0 0 1 18.611 154.639)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint6_linear_4099_10049)",
  fillRule: "evenodd",
  d: "M15.852 156.258h1v1h-1zm1 12.5h-1v1h1zm0 12.5h-1v1h1zm-2.5 0h-1v1h1zm-1-12.5h1v1h-1zm1-12.5h-1v1h1zm-3.5 25h1v1h-1zm1-12.5h-1v1h1zm-1-12.5h1v1h-1zm-1.5 25h-1v1h1zm-1-12.5h1v1h-1zm1-12.5h-1v1h1zm-3.5 25h1v1h-1zm1-12.5h-1v1h1zm-1-12.5h1v1h-1zm11 27.5h-1v1h1zm-1-12.5h1v1h-1zm1-12.5h-1v1h1zm-3.5 25h1v1h-1zm1-12.5h-1v1h1zm-1-12.5h1v1h-1zm-1.5 25h-1v1h1zm-1-12.5h1v1h-1zm1-12.5h-1v1h1zm-3.5 25h1v1h-1zm1-12.5h-1v1h1zm-1-12.5h1v1h-1zm-1.5 25h-1v1h1zm-1-12.5h1v1h-1zm1-12.5h-1v1h1zm9 27.5h1v1h-1zm1-12.5h-1v1h1zm-1-12.5h1v1h-1zm-1.5 25h-1v1h1zm-1-12.5h1v1h-1zm1-12.5h-1v1h1zm-3.5 25h1v1h-1zm1-12.5h-1v1h1zm-1-12.5h1v1h-1zm-1.5 25h-1v1h1zm-1-12.5h1v1h-1zm1-12.5h-1v1h1zm-3.5 25h1v1h-1zm1-12.5h-1v1h1zm-1-12.5h1v1h-1zm11 27.5h-1v1h1zm-1-12.5h1v1h-1zm1-12.5h-1v1h1zm-3.5 25h1v1h-1zm1-12.5h-1v1h1zm-1-12.5h1v1h-1zm-1.5 25h-1v1h1zm-1-12.5h1v1h-1zm1-12.5h-1v1h1zm-3.5 25h1v1h-1zm1-12.5h-1v1h1zm-1-12.5h1v1h-1zm-1.5 25h-1v1h1zm-1-12.5h1v1h-1zm1-12.5h-1v1h1zm9 27.5h1v1h-1zm1-12.5h-1v1h1zm-1-12.5h1v1h-1zm-1.5 25h-1v1h1zm-1-12.5h1v1h-1zm1-12.5h-1v1h1zm-3.5 25h1v1h-1zm1-12.5h-1v1h1zm-1-12.5h1v1h-1zm-1.5 25h-1v1h1zm-1-12.5h1v1h-1zm1-12.5h-1v1h1zm-3.5 25h1v1h-1zm1-12.5h-1v1h1zm-1-12.5h1v1h-1z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF8D3A",
  d: "M16.852 173.758h-1v1h1zm-2.5 12.5h-1v1h1zm-7.5-27.5h-1v1h1zm0 2.5h-1v1h1z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_ddiii_4099_10049)",
  shapeRendering: "crispEdges",
  transform: "matrix(-1 0 0 1 170.285 7.103)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.525,
  cy: 1.525,
  r: 1.525,
  fill: "#FF8310"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.525,
  cy: 1.525,
  r: 1.6,
  stroke: "#F27400",
  strokeOpacity: 0.5,
  strokeWidth: 0.15
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_bi_4099_10049)",
  transform: "matrix(-1 0 0 1 164.236 7.206)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.525,
  cy: 1.525,
  r: 1.525,
  fill: "url(#paint7_linear_4099_10049)",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.525,
  cy: 1.525,
  r: 1.45,
  stroke: "url(#paint8_linear_4099_10049)",
  strokeWidth: 0.15
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_f_4099_10049)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  fill: "#fff",
  fillOpacity: 0.15,
  rx: 0.5,
  transform: "matrix(-1 0 0 1 162.278 7)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_bi_4099_10049)",
  transform: "matrix(-1 0 0 1 158.187 7.206)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.525,
  cy: 1.525,
  r: 1.525,
  fill: "url(#paint9_linear_4099_10049)",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.525,
  cy: 1.525,
  r: 1.45,
  stroke: "url(#paint10_linear_4099_10049)",
  strokeWidth: 0.15
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_f_4099_10049)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  fill: "#fff",
  fillOpacity: 0.15,
  rx: 0.5,
  transform: "matrix(-1 0 0 1 156 7)"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint11_linear_4099_10049)",
  strokeDasharray: "2 1",
  strokeWidth: 0.5,
  d: "M1241.61 0H151.845L.801 114.745V676.5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint12_linear_4099_10049)",
  strokeDasharray: "2 1",
  strokeWidth: 0.5,
  d: "M268.44 699.5H593.5l56.511-67.5.001-597"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint13_linear_4099_10049)",
  strokeDasharray: "2 1",
  strokeWidth: 0.5,
  d: "M1188.61 490.393V-84.361"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint14_linear_4099_10049)",
  fillRule: "evenodd",
  d: "M1018.11 57h1v1h-1zm-2.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm-1.499 0h-1v1h1zm-3.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm-1.5 0h-1v1h1zm28.999 2.5h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.499 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm30.999 2.5h-1v1h1zm4 0h1v1h-1zm1-2.5h-1v1h1zm-8.5 2.5h1v1h-1zm6 0h-1v1h1zm-1-2.5h1v1h-1zm1-2.5h-1v1h1zm4 5h1v1h-1zm-11.5 0h-1v1h1zm-3.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm-1.499 0h-1v1h1zm-3.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm-1.5 0h-1v1h1zm28.999 2.5h1v1h-1zm6 0h-1v1h1zm4 0h1v1h-1zm-11.5 0h-1v1h1zm4 0h1v1h-1zm6 0h-1v1h1zm-13.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.499 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm30.999 2.5h-1v1h1zm4 0h1v1h-1zm6 0h-1v1h1zm1.5 0h1v1h-1zm-14 0h-1v1h1zm4 0h1v1h-1zm6 0h-1v1h1zm-13.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.499 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1zm-1.5 0h-1v1h1zm-3.5 0h1v1h-1z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF8D3A",
  d: "M991.611 64.5h-1v1h1zm17.499 2.5h-1v1h1zm7.5-10h-1v1h1z"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter6_bi_4099_10049)",
  transform: "matrix(0 -1 -1 0 660.922 62)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.525,
  cy: 1.525,
  r: 1.525,
  fill: "url(#paint15_linear_4099_10049)",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.525,
  cy: 1.525,
  r: 1.45,
  stroke: "url(#paint16_linear_4099_10049)",
  strokeWidth: 0.15
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter7_f_4099_10049)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  fill: "#fff",
  fillOpacity: 0.15,
  rx: 0.5,
  transform: "matrix(0 -1 -1 0 661.128 60.042)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter8_ddiii_4099_10049)",
  shapeRendering: "crispEdges",
  transform: "matrix(0 -1 -1 0 661.024 55.95)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.525,
  cy: 1.525,
  r: 1.525,
  fill: "#FF8310"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.525,
  cy: 1.525,
  r: 1.6,
  stroke: "#F27400",
  strokeOpacity: 0.5,
  strokeWidth: 0.15
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter9_bi_4099_10049)",
  transform: "matrix(0 -1 -1 0 660.922 49.902)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.525,
  cy: 1.525,
  r: 1.525,
  fill: "url(#paint17_linear_4099_10049)",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.525,
  cy: 1.525,
  r: 1.45,
  stroke: "url(#paint18_linear_4099_10049)",
  strokeWidth: 0.15
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter10_f_4099_10049)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  fill: "#fff",
  fillOpacity: 0.15,
  rx: 0.5,
  transform: "matrix(0 -1 -1 0 661.128 47.944)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter11_bi_4099_10049)",
  transform: "matrix(0 -1 -1 0 660.922 43.852)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.525,
  cy: 1.525,
  r: 1.525,
  fill: "url(#paint19_linear_4099_10049)",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.525,
  cy: 1.525,
  r: 1.45,
  stroke: "url(#paint20_linear_4099_10049)",
  strokeWidth: 0.15
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter12_f_4099_10049)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  fill: "#fff",
  fillOpacity: 0.15,
  rx: 0.5,
  transform: "matrix(0 -1 -1 0 661.128 41.666)"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_4099_10049",
  x1: -9,
  x2: 170,
  y1: -595,
  y2: 865,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6D6D6D",
  stopOpacity: 0.26
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#141414",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_4099_10049",
  x1: 1004.21,
  x2: 723.433,
  y1: -341,
  y2: 48.953,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D9D9D9",
  stopOpacity: 0.26
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#141414",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_4099_10049",
  x1: 515.979,
  x2: -268.203,
  y1: 1909.77,
  y2: -259.38,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6D6D6D",
  stopOpacity: 0.26
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#141414",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_4099_10049",
  x1: 18.616,
  x2: 18.422,
  y1: 123.335,
  y2: 154.949,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2B2B2B",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2B2B2B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_4099_10049",
  x1: -0.203,
  x2: -0.009,
  y1: 224.68,
  y2: 193.066,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2B2B2B",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2B2B2B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_4099_10049",
  x1: 15.409,
  x2: 15.409,
  y1: 104.09,
  y2: 154.639,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2B2B2B",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2B2B2B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_4099_10049",
  x1: 5.415,
  x2: 34.926,
  y1: 206.689,
  y2: 197.776,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#181818"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#282828"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_4099_10049",
  x1: 1.673,
  x2: 1.179,
  y1: -0.286,
  y2: 3.948,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8A8A8A",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#242424",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_4099_10049",
  x1: -2.148,
  x2: -2.974,
  y1: 5.891,
  y2: -3.759,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#525252"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.695
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_4099_10049",
  x1: 1.673,
  x2: 1.179,
  y1: -0.286,
  y2: 3.948,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8A8A8A",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#242424",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_4099_10049",
  x1: -2.148,
  x2: -2.974,
  y1: 5.891,
  y2: -3.759,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#525252"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.695
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_4099_10049",
  x1: 5.5,
  x2: 0.612,
  y1: 432.5,
  y2: 558.308,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2B2B2B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2B2B2B",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_4099_10049",
  x1: 492.02,
  x2: 192.579,
  y1: 265.436,
  y2: 331.773,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2B2B2B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2B2B2B",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_4099_10049",
  x1: 1181.59,
  x2: 1182.28,
  y1: 419.239,
  y2: 490.393,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2B2B2B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2B2B2B",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_4099_10049",
  x1: 986.384,
  x2: 1038.55,
  y1: 82.432,
  y2: 40.001,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#202020"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3E3E3E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_4099_10049",
  x1: 1.673,
  x2: 1.179,
  y1: -0.286,
  y2: 3.948,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8A8A8A",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#242424",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_4099_10049",
  x1: -2.148,
  x2: -2.974,
  y1: 5.891,
  y2: -3.759,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#525252"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.695
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_4099_10049",
  x1: 1.673,
  x2: 1.179,
  y1: -0.286,
  y2: 3.948,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8A8A8A",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#242424",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_4099_10049",
  x1: -2.148,
  x2: -2.974,
  y1: 5.891,
  y2: -3.759,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#525252"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.695
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear_4099_10049",
  x1: 1.673,
  x2: 1.179,
  y1: -0.286,
  y2: 3.948,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8A8A8A",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#242424",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear_4099_10049",
  x1: -2.148,
  x2: -2.974,
  y1: 5.891,
  y2: -3.759,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#525252"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.695
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter0_bdiii_4099_10049",
  width: 43,
  height: 67,
  x: -10.389,
  y: 140.639,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_4099_10049"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.9
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_backgroundBlur_4099_10049",
  result: "effect2_dropShadow_4099_10049"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_4099_10049",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 1,
  result: "effect3_innerShadow_4099_10049"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect3_innerShadow_4099_10049"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.45
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect3_innerShadow_4099_10049",
  result: "effect4_innerShadow_4099_10049"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 0.5,
  result: "effect5_innerShadow_4099_10049"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.01 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect4_innerShadow_4099_10049",
  result: "effect5_innerShadow_4099_10049"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_ddiii_4099_10049",
  width: 11.349,
  height: 12.349,
  x: 163.086,
  y: 3.953,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0745768 0 0 0 0 0.0356799 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4099_10049"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.478814 0 0 0 0 0 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_4099_10049",
  result: "effect2_dropShadow_4099_10049"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_4099_10049",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect3_innerShadow_4099_10049"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.806474 0 0 0 0 0.628955 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect3_innerShadow_4099_10049",
  result: "effect4_innerShadow_4099_10049"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.806474 0 0 0 0 0.628955 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect4_innerShadow_4099_10049",
  result: "effect5_innerShadow_4099_10049"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_bi_4099_10049",
  width: 31.049,
  height: 31.049,
  x: 147.187,
  y: -6.794,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_4099_10049"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_4099_10049",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect2_innerShadow_4099_10049"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_f_4099_10049",
  width: 5,
  height: 5,
  x: 159.278,
  y: 5,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_4099_10049",
  stdDeviation: 1
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_bi_4099_10049",
  width: 31.049,
  height: 31.049,
  x: 141.137,
  y: -6.794,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_4099_10049"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_4099_10049",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect2_innerShadow_4099_10049"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_f_4099_10049",
  width: 5,
  height: 5,
  x: 153,
  y: 5,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_4099_10049",
  stdDeviation: 1
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6_bi_4099_10049",
  width: 31.049,
  height: 31.049,
  x: 643.873,
  y: 44.951,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_4099_10049"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_4099_10049",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect2_innerShadow_4099_10049"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter7_f_4099_10049",
  width: 5,
  height: 5,
  x: 658.128,
  y: 57.042,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_4099_10049",
  stdDeviation: 1
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter8_ddiii_4099_10049",
  width: 11.349,
  height: 12.349,
  x: 653.825,
  y: 49.752,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0745768 0 0 0 0 0.0356799 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4099_10049"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.478814 0 0 0 0 0 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_4099_10049",
  result: "effect2_dropShadow_4099_10049"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_4099_10049",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect3_innerShadow_4099_10049"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.806474 0 0 0 0 0.628955 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect3_innerShadow_4099_10049",
  result: "effect4_innerShadow_4099_10049"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.806474 0 0 0 0 0.628955 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect4_innerShadow_4099_10049",
  result: "effect5_innerShadow_4099_10049"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter9_bi_4099_10049",
  width: 31.049,
  height: 31.049,
  x: 643.873,
  y: 32.852,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_4099_10049"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_4099_10049",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect2_innerShadow_4099_10049"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter10_f_4099_10049",
  width: 5,
  height: 5,
  x: 658.128,
  y: 44.944,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_4099_10049",
  stdDeviation: 1
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter11_bi_4099_10049",
  width: 31.049,
  height: 31.049,
  x: 643.873,
  y: 26.803,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_4099_10049"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_4099_10049",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect2_innerShadow_4099_10049"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter12_f_4099_10049",
  width: 5,
  height: 5,
  x: 658.128,
  y: 38.666,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_4099_10049",
  stdDeviation: 1
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4099_10049"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h1242v813H0z"
})))));
export { SvgContactBackground as ReactComponent };
export default __webpack_public_path__ + "static/ContactBackground.66900a09.svg";